// Generated by BUCKLESCRIPT VERSION 2.1.0, PLEASE EDIT WITH CARE
'use strict';

var Card        = require("./Card");
var List        = require("bs-platform/lib/js/list.js");
var View        = require("./View");
var $$Array     = require("bs-platform/lib/js/array.js");
var Block       = require("bs-platform/lib/js/block.js");
var Curry       = require("bs-platform/lib/js/curry.js");
var State       = require("./State");
var Utils       = require("./Utils");
var React       = require("react");
var Option      = require("./Option");
var V4          = require("uuid/v4");
var CardList    = require("./CardList");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");

var localStorageKey = "board";

function saveBoardLocally(board) {
  localStorage.setItem(localStorageKey, JSON.stringify(State.encodeBoard(board)));
  return /* () */0;
}

function getBoardFromLocalStorage() {
  var maybeResult = localStorage.getItem(localStorageKey);
  return Option.map((function (jsonString) {
                return State.decodeBoard(JSON.parse(jsonString));
              }), maybeResult === null ? /* None */0 : [maybeResult]);
}

function defaultInitialBoard() {
  return /* record */[
          /* name */"Welcome board",
          /* lists : :: */[
            CardList.create("1", /* Some */["This is a list"], /* Some */[/* :: */[
                    Card.create("1", /* Some */["This is a card"], /* () */0),
                    /* :: */[
                      Card.create("2", /* Some */["This is also a card"], /* () */0),
                      /* [] */0
                    ]
                  ]], /* () */0),
            /* :: */[
              CardList.create("2", /* Some */["This is another list"], /* Some */[/* :: */[
                      Card.create("3", /* Some */["This is a card"], /* () */0),
                      /* :: */[
                        Card.create("4", /* Some */["This is also a card"], /* () */0),
                        /* [] */0
                      ]
                    ]], /* () */0),
              /* [] */0
            ]
          ]
        ];
}

function initialState() {
  var maybeBoard = getBoardFromLocalStorage(/* () */0);
  var board = Option.withDefault(defaultInitialBoard(/* () */0), maybeBoard);
  return /* record */[
          /* board */board,
          /* newListForm : record */[
            /* name */"",
            /* isOpen : false */0,
            /* inputRef */[/* None */0]
          ],
          /* newCardForm : None */0,
          /* editListCid : None */0,
          /* editListInputRef */[/* None */0],
          /* isEditBoardNameFormOpen : false */0,
          /* drag : None */0
        ];
}

function reducer(action, state) {
  if (typeof action === "number") {
    switch (action) {
      case 0 : 
          return /* SideEffects */Block.__(2, [(function (self) {
                        return Curry._2(self[/* reduce */1], (function () {
                                      return /* AddListHelper */Block.__(0, [V4()]);
                                    }), /* () */0);
                      })]);
      case 1 : 
          var newrecord = state.slice();
          var init = state[/* newListForm */1];
          newrecord[/* newListForm */1] = /* record */[
            /* name */init[/* name */0],
            /* isOpen : true */1,
            /* inputRef */init[/* inputRef */2]
          ];
          return /* UpdateWithSideEffects */Block.__(3, [
                    newrecord,
                    (function (param) {
                        return Utils.Dom[/* focusElement */0](param[/* state */2][/* newListForm */1][/* inputRef */2]);
                      })
                  ]);
      case 2 : 
          var newrecord$1 = state.slice();
          var init$1 = state[/* newListForm */1];
          newrecord$1[/* newListForm */1] = /* record */[
            /* name */init$1[/* name */0],
            /* isOpen : false */0,
            /* inputRef */init$1[/* inputRef */2]
          ];
          return /* Update */Block.__(0, [newrecord$1]);
      case 3 : 
          var newrecord$2 = state.slice();
          return /* Update */Block.__(0, [(newrecord$2[/* newCardForm */2] = /* None */0, newrecord$2)]);
      case 4 : 
          var match = state[/* drag */6];
          if (match) {
            var match$1 = match[0][/* target */1];
            if (match$1.tag) {
              var match$2 = match$1[0];
              var match$3 = match$2[/* dropLocation */1];
              var index = match$3[1];
              var listCid = match$3[0];
              var card = match$2[/* item */0];
              var init$2 = state[/* board */0];
              return /* UpdateWithSideEffects */Block.__(3, [
                        /* record */[
                          /* board : record */[
                            /* name */init$2[/* name */0],
                            /* lists */List.map((function (list) {
                                    var match = +(list[/* cid */0] === listCid);
                                    if (match !== 0) {
                                      return /* record */[
                                              /* cid */list[/* cid */0],
                                              /* name */list[/* name */1],
                                              /* cards */Utils.List[/* insertAt */0](index, card, list[/* cards */2])
                                            ];
                                    } else {
                                      return list;
                                    }
                                  }), state[/* board */0][/* lists */1])
                          ],
                          /* newListForm */state[/* newListForm */1],
                          /* newCardForm */state[/* newCardForm */2],
                          /* editListCid */state[/* editListCid */3],
                          /* editListInputRef */state[/* editListInputRef */4],
                          /* isEditBoardNameFormOpen */state[/* isEditBoardNameFormOpen */5],
                          /* drag : None */0
                        ],
                        (function (param) {
                            return saveBoardLocally(param[/* state */2][/* board */0]);
                          })
                      ]);
            } else {
              var match$4 = match$1[0];
              var init$3 = state[/* board */0];
              return /* UpdateWithSideEffects */Block.__(3, [
                        /* record */[
                          /* board : record */[
                            /* name */init$3[/* name */0],
                            /* lists */Utils.List[/* insertAt */0](match$4[/* dropLocation */1], match$4[/* item */0], state[/* board */0][/* lists */1])
                          ],
                          /* newListForm */state[/* newListForm */1],
                          /* newCardForm */state[/* newCardForm */2],
                          /* editListCid */state[/* editListCid */3],
                          /* editListInputRef */state[/* editListInputRef */4],
                          /* isEditBoardNameFormOpen */state[/* isEditBoardNameFormOpen */5],
                          /* drag : None */0
                        ],
                        (function (param) {
                            return saveBoardLocally(param[/* state */2][/* board */0]);
                          })
                      ]);
            }
          } else {
            return /* NoUpdate */0;
          }
          break;
      case 5 : 
          var newrecord$3 = state.slice();
          return /* Update */Block.__(0, [(newrecord$3[/* editListCid */3] = /* None */0, newrecord$3)]);
      case 6 : 
          var newrecord$4 = state.slice();
          return /* Update */Block.__(0, [(newrecord$4[/* isEditBoardNameFormOpen */5] = /* true */1, newrecord$4)]);
      case 7 : 
          var newrecord$5 = state.slice();
          return /* Update */Block.__(0, [(newrecord$5[/* isEditBoardNameFormOpen */5] = /* false */0, newrecord$5)]);
      case 8 : 
          var newrecord$6 = state.slice();
          return /* Update */Block.__(0, [(newrecord$6[/* isEditBoardNameFormOpen */5] = 1 - state[/* isEditBoardNameFormOpen */5], newrecord$6)]);
      case 9 : 
          var init$4 = state[/* newListForm */1];
          return /* Update */Block.__(0, [/* record */[
                      /* board */state[/* board */0],
                      /* newListForm : record */[
                        /* name */init$4[/* name */0],
                        /* isOpen : false */0,
                        /* inputRef */init$4[/* inputRef */2]
                      ],
                      /* newCardForm : None */0,
                      /* editListCid : None */0,
                      /* editListInputRef */state[/* editListInputRef */4],
                      /* isEditBoardNameFormOpen : false */0,
                      /* drag */state[/* drag */6]
                    ]]);
      case 10 : 
          return /* NoUpdate */0;
      
    }
  } else {
    switch (action.tag | 0) {
      case 0 : 
          var init$5 = state[/* board */0];
          var init$6 = state[/* newListForm */1];
          return /* UpdateWithSideEffects */Block.__(3, [
                    /* record */[
                      /* board : record */[
                        /* name */init$5[/* name */0],
                        /* lists */List.append(state[/* board */0][/* lists */1], /* :: */[
                              CardList.create(action[0], /* Some */[state[/* newListForm */1][/* name */0]], /* None */0, /* () */0),
                              /* [] */0
                            ])
                      ],
                      /* newListForm : record */[
                        /* name */"",
                        /* isOpen */init$6[/* isOpen */1],
                        /* inputRef */init$6[/* inputRef */2]
                      ],
                      /* newCardForm */state[/* newCardForm */2],
                      /* editListCid */state[/* editListCid */3],
                      /* editListInputRef */state[/* editListInputRef */4],
                      /* isEditBoardNameFormOpen */state[/* isEditBoardNameFormOpen */5],
                      /* drag */state[/* drag */6]
                    ],
                    (function (param) {
                        return saveBoardLocally(param[/* state */2][/* board */0]);
                      })
                  ]);
      case 1 : 
          var newrecord$7 = state.slice();
          var init$7 = state[/* newListForm */1];
          newrecord$7[/* newListForm */1] = /* record */[
            /* name */action[0],
            /* isOpen */init$7[/* isOpen */1],
            /* inputRef */init$7[/* inputRef */2]
          ];
          return /* Update */Block.__(0, [newrecord$7]);
      case 2 : 
          var listCid$1 = action[0];
          return /* SideEffects */Block.__(2, [(function (self) {
                        return Curry._2(self[/* reduce */1], (function () {
                                      return /* AddCardToListHelper */Block.__(3, [
                                                listCid$1,
                                                V4()
                                              ]);
                                    }), /* () */0);
                      })]);
      case 3 : 
          var cardCid = action[1];
          var listCid$2 = action[0];
          var match$5 = state[/* newCardForm */2];
          if (match$5) {
            var newCardForm = match$5[0];
            var init$8 = state[/* board */0];
            return /* UpdateWithSideEffects */Block.__(3, [
                      /* record */[
                        /* board : record */[
                          /* name */init$8[/* name */0],
                          /* lists */List.map((function (list) {
                                  var match = +(list[/* cid */0] === listCid$2);
                                  if (match !== 0) {
                                    return /* record */[
                                            /* cid */list[/* cid */0],
                                            /* name */list[/* name */1],
                                            /* cards */List.append(list[/* cards */2], /* :: */[
                                                  Card.create(cardCid, /* Some */[newCardForm[/* name */1]], /* () */0),
                                                  /* [] */0
                                                ])
                                          ];
                                  } else {
                                    return list;
                                  }
                                }), state[/* board */0][/* lists */1])
                        ],
                        /* newListForm */state[/* newListForm */1],
                        /* newCardForm : Some */[/* record */[
                            /* listCid */newCardForm[/* listCid */0],
                            /* name */"",
                            /* inputRef */newCardForm[/* inputRef */2]
                          ]],
                        /* editListCid */state[/* editListCid */3],
                        /* editListInputRef */state[/* editListInputRef */4],
                        /* isEditBoardNameFormOpen */state[/* isEditBoardNameFormOpen */5],
                        /* drag */state[/* drag */6]
                      ],
                      (function (param) {
                          var state = param[/* state */2];
                          Option.run((function (newCardForm) {
                                  return Utils.Dom[/* focusElement */0](newCardForm[/* inputRef */2]);
                                }), state[/* newCardForm */2]);
                          return saveBoardLocally(state[/* board */0]);
                        })
                    ]);
          } else {
            return /* NoUpdate */0;
          }
          break;
      case 4 : 
          var newrecord$8 = state.slice();
          return /* UpdateWithSideEffects */Block.__(3, [
                    (newrecord$8[/* newCardForm */2] = /* Some */[/* record */[
                          /* listCid */action[0],
                          /* name */"",
                          /* inputRef */[/* None */0]
                        ]], newrecord$8),
                    (function (param) {
                        return Option.run((function (newCardForm) {
                                      return Utils.Dom[/* focusElement */0](newCardForm[/* inputRef */2]);
                                    }), param[/* state */2][/* newCardForm */2]);
                      })
                  ]);
      case 5 : 
          var match$6 = state[/* newCardForm */2];
          if (match$6) {
            var newCardForm$1 = match$6[0];
            var newrecord$9 = state.slice();
            return /* Update */Block.__(0, [(newrecord$9[/* newCardForm */2] = /* Some */[/* record */[
                            /* listCid */newCardForm$1[/* listCid */0],
                            /* name */action[0],
                            /* inputRef */newCardForm$1[/* inputRef */2]
                          ]], newrecord$9)]);
          } else {
            return /* NoUpdate */0;
          }
          break;
      case 6 : 
          var match$7 = state[/* drag */6];
          if (match$7) {
            var drag = match$7[0];
            var newrecord$10 = state.slice();
            return /* Update */Block.__(0, [(newrecord$10[/* drag */6] = /* Some */[/* record */[
                            /* movement : Moving */1,
                            /* target */drag[/* target */1],
                            /* initialClickOffset */drag[/* initialClickOffset */2],
                            /* mousePosition : tuple */[
                              action[0],
                              action[1]
                            ]
                          ]], newrecord$10)]);
          } else {
            return /* NoUpdate */0;
          }
          break;
      case 7 : 
          var drag$1 = action[0];
          var match$8 = drag$1[/* target */1];
          if (match$8.tag) {
            var card$1 = match$8[0][/* item */0];
            var init$9 = state[/* board */0];
            return /* Update */Block.__(0, [/* record */[
                        /* board : record */[
                          /* name */init$9[/* name */0],
                          /* lists */List.map((function (list) {
                                  return /* record */[
                                          /* cid */list[/* cid */0],
                                          /* name */list[/* name */1],
                                          /* cards */List.filter((function (c) {
                                                    return +(card$1[/* cid */0] !== c[/* cid */0]);
                                                  }))(list[/* cards */2])
                                        ];
                                }), state[/* board */0][/* lists */1])
                        ],
                        /* newListForm */state[/* newListForm */1],
                        /* newCardForm */state[/* newCardForm */2],
                        /* editListCid */state[/* editListCid */3],
                        /* editListInputRef */state[/* editListInputRef */4],
                        /* isEditBoardNameFormOpen */state[/* isEditBoardNameFormOpen */5],
                        /* drag : Some */[drag$1]
                      ]]);
          } else {
            var cardList = match$8[0][/* item */0];
            var init$10 = state[/* board */0];
            return /* Update */Block.__(0, [/* record */[
                        /* board : record */[
                          /* name */init$10[/* name */0],
                          /* lists */List.filter((function (list) {
                                    return +(list[/* cid */0] !== cardList[/* cid */0]);
                                  }))(state[/* board */0][/* lists */1])
                        ],
                        /* newListForm */state[/* newListForm */1],
                        /* newCardForm */state[/* newCardForm */2],
                        /* editListCid */state[/* editListCid */3],
                        /* editListInputRef */state[/* editListInputRef */4],
                        /* isEditBoardNameFormOpen */state[/* isEditBoardNameFormOpen */5],
                        /* drag : Some */[drag$1]
                      ]]);
          }
          break;
      case 8 : 
          var dropLocation = action[0];
          var match$9 = state[/* drag */6];
          if (match$9) {
            var drag$2 = match$9[0];
            var match$10 = drag$2[/* target */1];
            if (match$10.tag) {
              if (dropLocation.tag) {
                var newrecord$11 = state.slice();
                return /* Update */Block.__(0, [(newrecord$11[/* drag */6] = /* Some */[/* record */[
                                /* movement */drag$2[/* movement */0],
                                /* target : Card */Block.__(1, [/* record */[
                                      /* item */match$10[0][/* item */0],
                                      /* dropLocation */dropLocation[0]
                                    ]]),
                                /* initialClickOffset */drag$2[/* initialClickOffset */2],
                                /* mousePosition */drag$2[/* mousePosition */3]
                              ]], newrecord$11)]);
              } else {
                return /* NoUpdate */0;
              }
            } else if (dropLocation.tag) {
              return /* NoUpdate */0;
            } else {
              var newrecord$12 = state.slice();
              return /* Update */Block.__(0, [(newrecord$12[/* drag */6] = /* Some */[/* record */[
                              /* movement */drag$2[/* movement */0],
                              /* target : List */Block.__(0, [/* record */[
                                    /* item */match$10[0][/* item */0],
                                    /* dropLocation */dropLocation[0]
                                  ]]),
                              /* initialClickOffset */drag$2[/* initialClickOffset */2],
                              /* mousePosition */drag$2[/* mousePosition */3]
                            ]], newrecord$12)]);
            }
          } else {
            return /* NoUpdate */0;
          }
          break;
      case 9 : 
          var newrecord$13 = state.slice();
          return /* UpdateWithSideEffects */Block.__(3, [
                    (newrecord$13[/* editListCid */3] = /* Some */[action[0]], newrecord$13),
                    (function (param) {
                        return Utils.Dom[/* focusAndHighlightElement */1](param[/* state */2][/* editListInputRef */4]);
                      })
                  ]);
      case 10 : 
          var name = action[1];
          var cid = action[0];
          var newrecord$14 = state.slice();
          var init$11 = state[/* board */0];
          newrecord$14[/* board */0] = /* record */[
            /* name */init$11[/* name */0],
            /* lists */List.map((function (list) {
                    var match = +(list[/* cid */0] === cid);
                    if (match !== 0) {
                      return /* record */[
                              /* cid */list[/* cid */0],
                              /* name */name,
                              /* cards */list[/* cards */2]
                            ];
                    } else {
                      return list;
                    }
                  }), state[/* board */0][/* lists */1])
          ];
          return /* Update */Block.__(0, [newrecord$14]);
      case 11 : 
          var init$12 = state[/* board */0];
          return /* UpdateWithSideEffects */Block.__(3, [
                    /* record */[
                      /* board : record */[
                        /* name */action[0],
                        /* lists */init$12[/* lists */1]
                      ],
                      /* newListForm */state[/* newListForm */1],
                      /* newCardForm */state[/* newCardForm */2],
                      /* editListCid */state[/* editListCid */3],
                      /* editListInputRef */state[/* editListInputRef */4],
                      /* isEditBoardNameFormOpen : false */0,
                      /* drag */state[/* drag */6]
                    ],
                    (function (param) {
                        return saveBoardLocally(param[/* state */2][/* board */0]);
                      })
                  ]);
      
    }
  }
}

var component = ReasonReact.reducerComponent("App");

function listsForDisplay(state) {
  var match = state[/* drag */6];
  if (match) {
    var match$1 = match[0][/* target */1];
    if (match$1.tag) {
      var match$2 = match$1[0];
      var match$3 = match$2[/* dropLocation */1];
      var index = match$3[1];
      var listCid = match$3[0];
      var card = match$2[/* item */0];
      return List.map((function (list) {
                    var match = +(list[/* cid */0] === listCid);
                    if (match !== 0) {
                      return /* record */[
                              /* cid */list[/* cid */0],
                              /* name */list[/* name */1],
                              /* cards */Utils.List[/* insertAt */0](index, card, list[/* cards */2])
                            ];
                    } else {
                      return list;
                    }
                  }), state[/* board */0][/* lists */1]);
    } else {
      var match$4 = match$1[0];
      return Utils.List[/* insertAt */0](match$4[/* dropLocation */1], match$4[/* item */0], state[/* board */0][/* lists */1]);
    }
  } else {
    return state[/* board */0][/* lists */1];
  }
}

function isListBeingDragged(list, drag) {
  if (drag) {
    var drag$1 = drag[0];
    var match = drag$1[/* target */1];
    if (!match.tag && match[0][/* item */0][/* cid */0] === list[/* cid */0]) {
      return +(drag$1[/* movement */0] === /* Moving */1);
    } else {
      return /* false */0;
    }
  } else {
    return /* false */0;
  }
}

function handleKeyDown($$event) {
  var keyCode = $$event.keyCode;
  if (keyCode !== 27) {
    return /* NoOp */10;
  } else {
    return /* CloseAllOpenForms */9;
  }
}

function stopDragging() {
  return /* StopDragging */4;
}

function toggleEditingBoardName() {
  return /* ToggleEditingBoardName */8;
}

function changeListName(list, $$event) {
  return /* EditListName */Block.__(10, [
            list[/* cid */0],
            Utils.getValueFromEvent($$event)
          ]);
}

function startEditingListName(list, _) {
  return /* StartEditingListName */Block.__(9, [list[/* cid */0]]);
}

function stopEditingListName() {
  return /* StopEditingListName */5;
}

function startDraggingList(list, index, $$event) {
  return /* StartDragging */Block.__(7, [/* record */[
              /* movement : Started */0,
              /* target : List */Block.__(0, [/* record */[
                    /* item */list,
                    /* dropLocation */index
                  ]]),
              /* initialClickOffset */Utils.getClickOffsetFromEvent($$event),
              /* mousePosition */Utils.getMousePositionFromEvent($$event)
            ]]);
}

function startDraggingCard(card, listCid, cardIndex, $$event) {
  return /* StartDragging */Block.__(7, [/* record */[
              /* movement : Started */0,
              /* target : Card */Block.__(1, [/* record */[
                    /* item */card,
                    /* dropLocation : tuple */[
                      listCid,
                      cardIndex
                    ]
                  ]]),
              /* initialClickOffset */Utils.getClickOffsetFromEvent($$event),
              /* mousePosition */Utils.getMousePositionFromEvent($$event)
            ]]);
}

function setDropLocation(drag, list, listIndex, _) {
  if (drag) {
    var match = drag[0][/* target */1];
    if (match.tag) {
      return /* SetDropLocation */Block.__(8, [/* Card */Block.__(1, [/* tuple */[
                      list[/* cid */0],
                      List.length(list[/* cards */2])
                    ]])]);
    } else {
      return /* SetDropLocation */Block.__(8, [/* List */Block.__(0, [listIndex])]);
    }
  } else {
    return /* NoOp */10;
  }
}

function make() {
  var newrecord = component.slice();
  newrecord[/* render */9] = (function (param) {
      var state = param[/* state */2];
      var reduce = param[/* reduce */1];
      var handle = param[/* handle */0];
      var match = state[/* isEditBoardNameFormOpen */5];
      return ReasonReact.element(/* None */0, /* None */0, View.Container[/* make */1](Curry._1(reduce, (function ($$event) {
                            var match = Utils.getMousePositionFromEvent($$event);
                            return /* MoveDraggedItem */Block.__(6, [
                                      match[0],
                                      match[1]
                                    ]);
                          })), Curry._1(reduce, stopDragging), state[/* drag */6], Curry._1(reduce, handleKeyDown), /* array */[
                      ReasonReact.element(/* None */0, /* None */0, View.AppHeader[/* make */1](/* array */[])),
                      ReasonReact.element(/* None */0, /* None */0, View.BoardHeader[/* make */1](state[/* board */0][/* name */0], Curry._1(reduce, toggleEditingBoardName), /* array */[])),
                      React.createElement("div", {
                            className: "flex-auto flex flex-row overflow-x-scroll"
                          }, $$Array.of_list(List.mapi((function (index, list) {
                                      var partial_arg = state[/* drag */6];
                                      var match = state[/* editListCid */3];
                                      return ReasonReact.element(/* Some */[CardList.cidToString(list[/* cid */0])], /* None */0, View.CardList[/* make */1](list, /* Some */[isListBeingDragged(list, state[/* drag */6])], /* Some */[Curry._1(reduce, (function (param) {
                                                              return setDropLocation(partial_arg, list, index, param);
                                                            }))], /* Some */[Curry._1(reduce, (function ($$event) {
                                                              return startDraggingList(list, index, $$event);
                                                            }))], match ? +(match[0] === list[/* cid */0]) : /* false */0, Curry._1(reduce, (function (param) {
                                                            return changeListName(list, param);
                                                          })), Curry._1(reduce, (function () {
                                                            return /* StartEditingListName */Block.__(9, [list[/* cid */0]]);
                                                          })), Curry._1(reduce, stopEditingListName), (function (cardIndex, card) {
                                                        var match = state[/* drag */6];
                                                        var tmp;
                                                        if (match) {
                                                          var drag = match[0];
                                                          var match$1 = drag[/* target */1];
                                                          tmp = match$1.tag ? +(match$1[0][/* item */0][/* cid */0] === card[/* cid */0] && drag[/* movement */0] === /* Moving */1) : /* false */0;
                                                        } else {
                                                          tmp = /* false */0;
                                                        }
                                                        return ReasonReact.element(/* None */0, /* None */0, View.Card[/* make */1](card, Curry._1(reduce, (function ($$event) {
                                                                              return startDraggingCard(card, list[/* cid */0], cardIndex, $$event);
                                                                            })), Curry._1(reduce, (function () {
                                                                              return /* SetDropLocation */Block.__(8, [/* Card */Block.__(1, [/* tuple */[
                                                                                              list[/* cid */0],
                                                                                              cardIndex
                                                                                            ]])]);
                                                                            })), /* Some */[tmp], /* array */[]));
                                                      }), Curry._1(handle, (function (theRef, param) {
                                                            param[/* state */2][/* editListInputRef */4][0] = (theRef == null) ? /* None */0 : [theRef];
                                                            return /* () */0;
                                                          })), /* array */[ReasonReact.element(/* None */0, /* None */0, View.NewCardForm[/* make */3](state[/* newCardForm */2], Curry._1(reduce, (function ($$event) {
                                                                      return /* SetNewCardName */Block.__(5, [Utils.getValueFromEvent($$event)]);
                                                                    })), list[/* cid */0], Curry._1(reduce, (function () {
                                                                      return /* AddCardToList */Block.__(2, [list[/* cid */0]]);
                                                                    })), Curry._1(reduce, (function () {
                                                                      return /* OpenNewCardForm */Block.__(4, [list[/* cid */0]]);
                                                                    })), Curry._1(reduce, (function () {
                                                                      return /* CloseNewCardForm */3;
                                                                    })), Curry._1(handle, (function (theRef, param) {
                                                                      return Option.run((function (newCardForm) {
                                                                                    newCardForm[/* inputRef */2][0] = (theRef == null) ? /* None */0 : [theRef];
                                                                                    return /* () */0;
                                                                                  }), param[/* state */2][/* newCardForm */2]);
                                                                    })), /* array */[]))]));
                                    }), listsForDisplay(state))), ReasonReact.element(/* None */0, /* None */0, View.AddListForm[/* make */3](state[/* newListForm */1], Curry._1(reduce, (function () {
                                          return /* AddList */0;
                                        })), Curry._1(reduce, (function ($$event) {
                                          return /* SetNewListName */Block.__(1, [Utils.getValueFromEvent($$event)]);
                                        })), Curry._1(reduce, (function () {
                                          return /* OpenNewListForm */1;
                                        })), Curry._1(reduce, (function () {
                                          return /* CloseNewListForm */2;
                                        })), Curry._1(handle, (function (theRef, param) {
                                          param[/* state */2][/* newListForm */1][/* inputRef */2][0] = (theRef == null) ? /* None */0 : [theRef];
                                          return /* () */0;
                                        })), /* array */[]))),
                      ReasonReact.element(/* None */0, /* None */0, View.DraggedItem[/* make */1](state[/* drag */6], state[/* newCardForm */2], /* array */[])),
                      match !== 0 ? ReasonReact.element(/* None */0, /* None */0, View.EditBoardNamePopup[/* make */3](state[/* board */0][/* name */0], Curry._1(reduce, (function () {
                                        return /* CloseEditBoardNameForm */7;
                                      })), Curry._1(reduce, (function (name) {
                                        return /* SetBoardName */Block.__(11, [name]);
                                      })), /* array */[])) : null
                    ]));
    });
  newrecord[/* initialState */10] = initialState;
  newrecord[/* reducer */12] = reducer;
  return newrecord;
}

exports.localStorageKey          = localStorageKey;
exports.saveBoardLocally         = saveBoardLocally;
exports.getBoardFromLocalStorage = getBoardFromLocalStorage;
exports.defaultInitialBoard      = defaultInitialBoard;
exports.initialState             = initialState;
exports.reducer                  = reducer;
exports.component                = component;
exports.listsForDisplay          = listsForDisplay;
exports.isListBeingDragged       = isListBeingDragged;
exports.handleKeyDown            = handleKeyDown;
exports.stopDragging             = stopDragging;
exports.toggleEditingBoardName   = toggleEditingBoardName;
exports.changeListName           = changeListName;
exports.startEditingListName     = startEditingListName;
exports.stopEditingListName      = stopEditingListName;
exports.startDraggingList        = startDraggingList;
exports.startDraggingCard        = startDraggingCard;
exports.setDropLocation          = setDropLocation;
exports.make                     = make;
/* component Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/app.re
// module id = 35
// module chunks = 0